module.exports = __webpack_public_path__ + "assets/img/1951591928118_.pic_hd.030e4371.jpg";